import type React from "react";

type Props = {
  children: React.ReactNode;
};

export const LayoutCheckoutTable = ({ children }: Props): JSX.Element => {
  return (
    <div className="table-responsive">
      <table className="table ps-table--shopping-cart table-bordered">
        {children}
      </table>
    </div>
  );
};
